import React, {useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {Dialog} from '@pb/kit-component-dialog-v2';

import type {
    BulkActionIdSelector,
    BulkActionShownSelector,
    BulkActionTaskSelector,
    ClearResult,
} from './typedef';

type ModalProps = {
    id: string,
    onClose: () => void,
};

type Props = {
    children: ({id, onClose}: ModalProps) => React.ReactElement,
    actionIdSelector: BulkActionIdSelector,
    actionTaskSelector: BulkActionTaskSelector,
    actionShownSelector: BulkActionShownSelector,
    clearResult: ClearResult,
};

export const BulkActionResult = (props: Props) => {
    const {children, actionIdSelector, actionTaskSelector, actionShownSelector, clearResult} = props;
    const dispatch = useDispatch();

    const id = useSelector(actionIdSelector);
    const shown = useSelector(actionShownSelector);
    const backgroundTask = useSelector(actionTaskSelector);

    const closeModal = useCallback(() => {
        dispatch(clearResult());
    }, [dispatch, clearResult]);

    return (
        <Dialog
            shown={shown ? !!backgroundTask : false}
            setShown={closeModal}
            wrapperProps={{style: {width: 'fit-content'}}}>
            {children({id, onClose: closeModal})}
        </Dialog>
    );
};
